<template>
  <div class="nest-page">
    <a-card>
      <a-button v-if="btnPerm.dataAttr.add.indexOf(currentRole.roleId) !== -1"
        @click="addCategory"
        type="primary">增加一类</a-button>
      <a-select
        v-if="currentRole.roleId === '7'"
        v-model:value="selectTeamId"
        style="margin-left: 20px; width: 120px">
        <a-select-option v-for="t in teamList"
          :key="t.id"
          :value="t.id">
          {{ t.name }}
        </a-select-option>
      </a-select>
      <div
        class="attr-card"
        v-for="(item) in currentList"
        :key="item.id">
        <NestedTree
          :data="item"
          :childrens="item.children"
          @deleteChild="deleteCategory"
          @updateChild="updateChild"
          @changeChildType="changeChildType"
          @updateAll="getAllCategory">
        </NestedTree>
      </div>
    </a-card>
    <a-modal v-model:visible="inputVisible" title="请输入名称" @ok="confirmAdd">
      <a-input v-model:value="inputValue" placeholder="请输入名称"></a-input>
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import NestedTree from './NestedTree'
import config from '@/config'
import {
  getAllAttrCategory,
  addAttrCategory,
  deleteAttrCategory
} from '@/api/dataAttr'
export default {
  components: {
    NestedTree
  },
  data () {
    return {
      btnPerm: config.btnPerm,
      selectTeamId: '',
      list: [],
      inputValue: '',
      inputVisible: false
    }
  },
  computed: {
    ...mapState(['currentRole', 'teamList']),
    currentList () {
      return this.list.filter(i => !this.selectTeamId || i.teamId === this.selectTeamId)
    }
  },
  mounted () {
    if (this.currentRole.roleId === '7') {
      if (this.teamList[0]) {
        this.selectTeamId = this.teamList[0].id
      } else {
        return
      }
    }
    this.getAllCategory()
  },
  methods: {
    getAllCategory () {
      this.list = []
      getAllAttrCategory().then(async res => {
        this.list = res.data.map.data
      })
    },

    deleteCategory (id) {
      deleteAttrCategory(id).then(res => {
        const index = this.list.findIndex(i => i.id === id)
        if (index !== -1) {
          this.list.splice(index, 1)
        }
      })
    },
    updateChild (params) {
      const item = this.list.find(i => i.id === params.id)
      if (item) {
        item.chineseInstructions = params.chineseInstructions
      }
    },
    changeChildType (params) {
      const item = this.list.find(i => i.id === params.id)
      if (item) {
        item.type = params.type
      }
    },
    addCategory () {
      this.inputValue = ''
      this.inputVisible = true
    },
    confirmAdd () {
      if (!this.checkInput()) {
        return
      }
      addAttrCategory({
        chineseInstructions: this.inputValue
      }).then(res => {
        const item = res.data.map.itemKey
        item.type = 'category'
        this.list.unshift(item)
        this.inputVisible = false
      })
    },
    checkInput () {
      if (!this.inputValue) {
        this.$message.error('名称不能为空')
        return false
      }
      return true
    }
  }
}
</script>
<style lang="less">
.nest-page {
  .filter-section {
    margin: 0 0 10px;
  }
  .attr-card {
    margin: 10px 0 20px;
  }
}
</style>
